import React from 'react';
import MainLayout from '@views/layouts/main-layout';
import OrderChecking from '@views/modules/order-checking';
import { NextSeo } from 'next-seo';

export const OrderCheckingPage = () => (
  <MainLayout>
    <NextSeo title="Tra cứu đơn hàng" />
    <OrderChecking />
  </MainLayout>
);

export default OrderCheckingPage;
